module.exports = __webpack_public_path__ + "img/img7.b75c1ced.jpg";